export interface XliffSegment {
  id: string
  source: string
  target: string
  state?: string
  approved?: boolean
}

export interface XliffParseResult {
  segments: XliffSegment[]
  sourceLanguage: string
  targetLanguage: string
  version: '1.2' | '2.0' | 'unknown'
}

export function parseXliff(content: string): XliffParseResult {
  const parser = new DOMParser()
  const doc = parser.parseFromString(content, 'application/xml')
  const xliffEl = doc.querySelector('xliff')
  const version = xliffEl?.getAttribute('version')
  const isV2 = version?.startsWith('2')
  if (isV2) return parseXliff2(doc)
  return parseXliff12(doc)
}

function parseXliff12(doc: Document): XliffParseResult {
  const fileEl = doc.querySelector('file')
  const sourceLanguage = fileEl?.getAttribute('source-language') || 'en'
  const targetLanguage = fileEl?.getAttribute('target-language') || ''
  const transUnits = Array.from(doc.querySelectorAll('trans-unit'))
  const segments: XliffSegment[] = []
  for (const unit of transUnits) {
    const id = unit.getAttribute('id') || String(segments.length + 1)
    const source = getTextContent(unit.querySelector('source'))
    const target = getTextContent(unit.querySelector('target'))
    const state = unit.querySelector('target')?.getAttribute('state') || ''
    const approved = unit.getAttribute('approved') === 'yes'
    if (source.trim()) segments.push({ id, source, target, state, approved })
  }
  return { segments, sourceLanguage, targetLanguage, version: '1.2' }
}

function parseXliff2(doc: Document): XliffParseResult {
  const xliffEl = doc.querySelector('xliff')
  const sourceLanguage = xliffEl?.getAttribute('srcLang') || 'en'
  const targetLanguage = xliffEl?.getAttribute('trgLang') || ''
  const units = Array.from(doc.querySelectorAll('unit, segment'))
  const segments: XliffSegment[] = []
  for (const unit of units) {
    const id = unit.getAttribute('id') || String(segments.length + 1)
    const source = getTextContent(unit.querySelector('source'))
    const target = getTextContent(unit.querySelector('target'))
    const state = unit.getAttribute('state') || ''
    if (source.trim()) segments.push({ id, source, target, state })
  }
  return { segments, sourceLanguage, targetLanguage, version: '2.0' }
}

function getTextContent(el: Element | null): string {
  if (!el) return ''
  const clone = el.cloneNode(true) as Element
  clone.querySelectorAll('x, bx, ex, ph').forEach(n => n.remove())
  return clone.textContent?.trim() || ''
}

export function detectXliffLanguages(content: string): { source: string; target: string } | null {
  try {
    const result = parseXliff(content)
    if (result.sourceLanguage && result.targetLanguage) {
      return { source: result.sourceLanguage, target: result.targetLanguage }
    }
    return null
  } catch { return null }
}
